import { timestampToLocalTime } from "anka-endeavour";
import DataTable from "../components/DataTable";
import { hostname } from "../hooks/useEndeavour";
import { Link } from "react-router-dom";
import { Form, Input, DatePicker, Button, Space } from "antd";
import { AppstoreAddOutlined, EditOutlined } from "@ant-design/icons";
import AddCampaignModal from "../components/AddCampaignModal";
import UpdateCampaignSortModal from "../components/UpdateCampaignSortModal";
import UpdateCampaignModal from "../components/UpdateCampaignModal";
import { useRef, useState } from "react";
import { CreateNotificationModal } from "../components/CreateNotificationModal";

export default function CampaignsPage() {
  const [forceUpdate, setForceUpdate] = useState(0);
  const createNotificationRef = useRef();
  const campaignsRef = useRef();
  const sortCampaignsRef = useRef();
  const updateCampaignRef = useRef();
  const onClickContact = () => {
    campaignsRef.current.openModal();
  };
  const onClickSort = () => {
    sortCampaignsRef.current.openModal();
  };
  const onCUpdateContact = (data) => {
    updateCampaignRef.current.openModal(data);
  };
  const onUpdate = () => {
    setForceUpdate(forceUpdate + 1);
  };
  return (
    <>
      <CreateNotificationModal ref={createNotificationRef} onChange={forceUpdate} />
      <AddCampaignModal ref={campaignsRef} onChange={onUpdate} />
      <UpdateCampaignSortModal ref={sortCampaignsRef} />
      <UpdateCampaignModal ref={updateCampaignRef} onChange={onUpdate} />
      <DataTable
        uri={`${hostname}/pa-alliance/campaign`}
        ForceUpdate={forceUpdate}
        tableTitle={
          <Space>
            <Button
              type="primary"
              icon={<AppstoreAddOutlined />}
              onClick={() => {
                onClickContact();
              }}
            >
              Create Campaign
            </Button>
            <Button
              type="primary"
              icon={<AppstoreAddOutlined />}
              onClick={() => {
                onClickSort();
              }}
            >
              Update Campaign Sort
            </Button>
          </Space>
        }
        name="Campaigns"
        filters={[
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>,
          <Form.Item label="Type" name="type">
            <Input />
          </Form.Item>,
          <Form.Item label="Description" name="description">
            <Input />
          </Form.Item>,
        ]}
        tableColumns={[
          {
            title: "Name",

            render: (data) => {
              return <Link to={`/campaign/${data.id}`}>{data.name}</Link>;
            },
          },
          {
            title: "Type",
            render: (data) => {
              switch (data.type) {
                case "lucky_draw":
                  return "Lucky Draw";
                case "subscription":
                  return "Subscription";
                default:
                  return data.type;
              }
            },
          },
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "Start Date",
            render: (data) => {
              return timestampToLocalTime(data.start_at);
            },
          },
          {
            title: "End Date",
            render: (data) => {
              return timestampToLocalTime(data.expired_at);
            },
          },

          {
            title: "Action",
            render: (data) => {
              return (
                <Space>
                  <Button icon={<EditOutlined />} onClick={() => onCUpdateContact(data)} type="primary">
                    Edit
                  </Button>
                  <Button
                    icon={<EditOutlined />}
                    onClick={() =>
                      createNotificationRef.current.showModal({
                        channel: "marketing",
                        page: "concert",
                        campaign_id: data.id,
                      })
                    }
                    type="primary"
                  >
                    Create Notification Task
                  </Button>
                </Space>
              );
            },
          },
        ]}
      />
    </>
  );
}
